// dependencies
import { fromJS } from "immutable";

export default fromJS({
	currentPage: 1,
	requestsCount: 1,
	pageSize: 25,
	requests: [],
	methodOptions: [
		{ id: "get", label: "GET" },
		{ id: "post", label: "POST" },
		{ id: "delete", label: "DELETE" },
	],
	authenticatedOptions: [
		{ id: "true", label: "Logged In" },
		{ id: "false", label: "Logged Out" },
	],
	possessedOptions: [
		{ id: "true", label: "Possessed" },
		{ id: "false", label: "Not Possessed" },
	],
});
